export default {
      id: "weather__day-rainy-1-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "img/icons.svg#weather__day-rainy-1",
      toString: function () {
        return this.url;
      }
    }